import axios from "axios";
import type {SubscriptionPaymentLink, SubscriptionPrice} from "@/scripts/types/subscription";
import {PlanType} from "@/scripts/types/account";

export const createRenewSubscriptionInvoice = async (plan: PlanType, months: number) => {
    const url = '/api/billing/createSubscription';
    const response = await axios.get(url, {
        params: {
            plan: plan,
            months: months
        }
    });

    return response.data as SubscriptionPaymentLink;
};

export const createUpgradeSubscriptionInvoice = async (plan: PlanType) => {
    const url = '/api/billing/upgradeSubscription';
    const response = await axios.get(url, {
        params: {
            plan: plan,
        }
    });

    return response.data as SubscriptionPaymentLink;
};

let subscriptionPriceAbortController = new AbortController();
export const calculateSubscription = async (plan: PlanType, months: number) => {
    const url = '/api/billing/calculateSubscription';
    subscriptionPriceAbortController.abort()
    subscriptionPriceAbortController = new AbortController();
    const response = await axios.get(url, {
        signal: subscriptionPriceAbortController.signal,
        params: {
            plan: plan,
            months: months
        }
    });

    return response.data as SubscriptionPrice;
};

export const calculateUpgradePrice = async (plan: PlanType) => {
    const url = '/api/billing/calculateUpgradePrice';
    subscriptionPriceAbortController.abort()
    subscriptionPriceAbortController = new AbortController();
    const response = await axios.get(url, {
        signal: subscriptionPriceAbortController.signal,
        params: {
            plan: plan,
        }
    });

    return response.data as SubscriptionPrice;
};